<template>
  <v-autocomplete
    v-model="params[type]"
    :items="items"
    :item-text="itemText"
    :item-value="valueKey"
    :return-object="false"
    :label="label"
    :loading="loading"
    :disabled="disabled"
    :multiple="multiple"
    :hide-no-data="hideNoData"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendIcon"
    :no-data-text="noDataText ? noDataText : $t('appointment.filters.noData')"
    :search-input.sync="search"
    cache-items
    autocomplete="off"
    ref="input"
    single-line
    clearable
    outlined
    small
    dense
    @change="applyFilter"
    @click:clear="clearFilter"
  >
    <template v-slot:selection="data">
      <span class="d-block text-truncate text-comma mr-2">
        {{ itemText ? data.item[itemText] : data.item.name }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'FilterAutocomplete',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    label: {
      type: String,
      default: 'Filtro',
    },

    type: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      default: 'value',
    },

    itemText: {
      default: 'name',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    asyncSearch: {
      type: Function,
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hideNoData: {
      type: Boolean,
      default: false,
    },

    prependInnerIcon: {
      type: String,
      default: '',
    },

    appendIcon: {
      type: String,
      default: '$dropdown'
    },

    noDataText: {
      type: String,
    },

    /** Seleção inicial. Sem ela o comportamento é o de antes: filtro começa vazio. */
    initialValue: {
      default: undefined,
    },
  },

  data () {
    return {
      params: {},
      search: null,
      _timer: null,
      _customTimer: null,
    }
  },

  computed: {
    ...mapGetters(['filters']),
    valueKey () {
      return this.value || 'value'
    },
  },

  watch: {
    search (value) {
      this.asyncSearch && this.handleAsyncSearch(value)
    },
  },

  created() {
    if (this.initialValue === undefined) return
    this.params[this.type] = this.initialValue
    this.setFilters({ ...store.getters.filters, [this.type]: this.normalizeValue(this.initialValue) })
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    applyFilter() {
      this.handleFilter()
    },

    normalizeValue (val) {
      const pick = (obj) => {
        if (!obj || typeof obj !== 'object') return obj ?? null
        return obj[this.valueKey] ?? obj.value ?? obj.code ?? obj.id ?? null
      }
      if (Array.isArray(val)) return val.map(v => this.normalizeValue(v))
      if (val && typeof val === 'object') return pick(val)
      return val ?? null
    },

    handleFilter() {
      clearTimeout(this._timer)

      this._timer = setTimeout(() => {
        const normalized = this.normalizeValue(this.params[this.type])
        const next = { ...store.getters.filters, [this.type]: normalized }

        Promise
          .resolve(this.setFilters(next))
          .then(() => this.setCurrentPage(1))
          .then(() => {
            this.fetchData()
            this.$emit('filterSetted', next[this.type])
          })
      }, 500)
    },

    clearFilter() {
      this.params[this.type] = this.multiple ? [] : null
      this.search = null
      this.handleFilter()
    },

    handleAsyncSearch(value) {
      clearTimeout(this._customTimer)
      this._customTimer = setTimeout(() => {
        this.asyncSearch && this.asyncSearch(value)
      }, 750)
    },

    clearInput() {
      if (this.$refs.input && this.$refs.input.reset) this.$refs.input.reset()
    },
  },
}
</script>
